import { CropChip } from '@cibo/ui'
import { DetailSimpleCellProps } from '../types'

export const CashCropDetailSimpleCell = ({ detail }: DetailSimpleCellProps) => {
  return <CropChip crop={detail?.result} source={detail?.source} />
}
